import { Navigate } from 'react-router-dom';
import { useVerificationStatus } from '@/hooks/useVerificationStatus';
import { BrandLoader } from '@/components/ui/brand-loader';

export function VerifiedRoute({ children }: { children: React.ReactNode }) {
  const { isVerified, hasTeamAccess, loading } = useVerificationStatus();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <BrandLoader size={48} />
      </div>
    );
  }

  // Verified users always pass; team members pass (trainee access)
  if (isVerified || hasTeamAccess) {
    return <>{children}</>;
  }

  // Not allowed — redirect back to dashboard
  return <Navigate to="/home" replace />;
}
